export default __webpack_public_path__ + "static/media/line.75ef205d.svg";